import type { FaireProductEntity } from "../../entity_types/product";

export const p_6bdmz4383y: FaireProductEntity = {
  token: "p_6bdmz4383y",
  type: "product",
  name: "Tomato Washed Baseball Cap/Dad Hat",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/fc50042b16c2ab3e4b1b4b82165848c6f7cbc869687b7d94494d744533ad7b1a.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9da50b66f7d7e0ded9608a6270e569c8d5d93d117f0e7889fdd3f18f27bb7d05.jpeg"
  ],
  priceDollars: 17.5,
  description: "Brighten up your everyday looks with the Tomato Dad Hat. Soft, adjustable, and perfect for foodies or anyone who loves playful, design-forward accessories. A fun, colorful hat for errands, casual outings, or gifting.\n\n\nGood to know:\n\n * Washed blue hat with embroidered tomato \n * Features adjustable back buckle \n * Designed in Kingston, NY by Mel Andrel ",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:08.434Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
